import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'epay-howtos',
  templateUrl: './howtos.component.html'
})
export class HowTosComponent implements OnInit {

  pagetitle = 'SMI North Dakota Internet Payment Website Help';
  constructor() { }

  ngOnInit(): void {
  }

}
